import DashboardAbsensi from "../../../../../components/categories/siakad/lms/dashboards_absensi/HomeTeacher";
export default function Home() {
  
  return (
    <DashboardAbsensi />
  );
}